import { ACCOUNT_SLUG_DETAILS } from '../actionTypes';
import CONSTANTS from '../constants';

const initialState = {
  accountSlugDetailsStatus: undefined,
  accountSlugDetailsError: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNT_SLUG_DETAILS.FETCH:
      return {
        ...state,
        accountSlugDetailsStatus: CONSTANTS.API_STATUS.STARTED,
      };
    case ACCOUNT_SLUG_DETAILS.SUCCESS:
      return {
        ...state,
        ...action.payload,
        accountSlugDetailsStatus: CONSTANTS.API_STATUS.SUCCEEDED,
      };
    case ACCOUNT_SLUG_DETAILS.FAILED:
      return {
        ...state,
        accountSlugDetailsError: action.payload,
        accountSlugDetailsStatus: CONSTANTS.API_STATUS.FAILED,
      };
    default:
      return state;
  }
};
